<template>
  <div class="card" v-show="currentCardId == 'hobby'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>自分の趣味を選択する</h2>
        <p>記載したい趣味を選択してください</p>
      </div>
      <div class="card-content-list">
        <div class="edit-hobby-list">
          <figure
            v-for="(item, idx) in hobbyOptions"
            :key="item.label"
            :class="checkedHobby(idx)"
            style="cursor: pointer"
            @click="selectHobby(idx, item.label)"
          >
            <img :src="item.image" />
            <figcaption>{{ item.label }}</figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import hobbyOptions from '@/utils/format-edit/designRirekishoHobbyOptions.json'

defineProps<{
  currentCardId?: string
}>()

const { message } = useHostServices()
const formatData = useRirekishoFormatData()

function ensureHobbies() {
  if (!formatData.hobbies) {
    formatData.hobbies = []
  }
  return formatData.hobbies
}

function selectHobby(idx: number, val: string) {
  const hobbies = ensureHobbies()
  let isExistIndex = -1
  for (let i = 0; i < hobbies.length; i++) {
    if (hobbies[i].id === idx) {
      isExistIndex = i
      break
    }
  }
  if (isExistIndex >= 0) {
    hobbies.splice(isExistIndex, 1)
    return
  }
  if (hobbies.length >= 9) {
    message({
      message: '趣味は最大9つまで選択可能です。',
      type: 'error'
    })
    return
  }
  hobbies.push({ id: idx, name: val })
}

function checkedHobby(idx: number) {
  const hobbies = formatData.hobbies || []
  for (let i = 0; i < hobbies.length; i++) {
    if (hobbies[i].id === idx) {
      return 'seleted'
    }
  }
  return ''
}
</script>

<style lang="scss" scoped>
.edit-hobby-list {
  display: flex;
  flex-wrap: wrap;
  padding: 1rem 1.5rem 1.5rem;
  justify-content: center;
}

.edit-hobby-list figure {
  text-align: center;
  padding: 8px;
  width: 80px;
  height: 80px;
  margin: 5px;
}

.edit-hobby-list .seleted {
  border: 2px solid #99b8b3;
  border-radius: 5px;
}

.edit-hobby-list figure img {
  width: 50px;
}

.edit-hobby-list figure figcaption {
  font-size: 0.6rem;
}
</style>
